import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02e96b13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-page" }
const _hoisted_2 = { class: "fixed-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fixed-eyebrow" }, "Sua rotina financeira"),
  /*#__PURE__*/_createElementVNode("h1", null, "Compromissos fixos")
], -1))
const _hoisted_4 = { class: "fixed-header__actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "fixed-workspace" }
const _hoisted_7 = {
  class: "estimate-card",
  "aria-labelledby": "estimate-title"
}
const _hoisted_8 = { class: "estimate-card__content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "estimate-card__label" }, "Estimativa mensal", -1))
const _hoisted_10 = { id: "estimate-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Média dos seus compromissos semanais, mensais e anuais.", -1))
const _hoisted_12 = {
  key: 0,
  class: "estimate-warning"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-plus",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Cadastrar"),
  /*#__PURE__*/_createElementVNode("strong", null, "Novo compromisso")
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  class: "agenda-panel",
  "aria-labelledby": "agenda-title"
}
const _hoisted_17 = { class: "agenda-heading" }
const _hoisted_18 = { id: "agenda-title" }
const _hoisted_19 = { class: "agenda-heading__actions" }
const _hoisted_20 = {
  key: 0,
  class: "agenda-heading__hint"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_22 = ["aria-label", "title"]
const _hoisted_23 = {
  class: "agenda-tabs",
  role: "tablist",
  "aria-label": "Filtrar compromissos"
}
const _hoisted_24 = ["aria-selected", "onClick"]
const _hoisted_25 = {
  key: 0,
  class: "fixed-feedback fixed-feedback--error",
  role: "alert"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_27 = {
  key: 1,
  class: "fixed-skeletons",
  role: "status",
  "aria-label": "Carregando compromissos"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--date" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--content" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--amount" }, null, -1))
const _hoisted_31 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "calendar-toolbar" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "fixed-feedback fixed-feedback--error",
  role: "alert"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_39 = {
  key: 1,
  class: "calendar-loading",
  role: "status",
  "aria-label": "Carregando calendário"
}
const _hoisted_40 = ["aria-label"]
const _hoisted_41 = ["aria-label", "aria-pressed", "onClick"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  ref: "calendarSelection",
  class: "calendar-selection",
  tabindex: "-1"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Compromissos do dia", -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "calendar-empty"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-calendar-blank",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhum compromisso neste mês.", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "agenda-list" }
const _hoisted_52 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_53 = {
  key: 1,
  class: "ph ph-calendar-blank",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "fixed-item__main" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { "aria-hidden": "true" }, "•", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Vencimento", -1))
const _hoisted_57 = { class: "fixed-item__amount" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right fixed-item__arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_59 = { class: "pagination-row" }
const _hoisted_60 = { class: "pagination-row__summary" }
const _hoisted_61 = { class: "pagination-actions" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["aria-current", "onClick"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "pagination-mobile" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = ["disabled"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 4,
  class: "empty-fixed"
}
const _hoisted_73 = {
  key: 0,
  class: "fixed-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "detail-title"
}
const _hoisted_74 = { class: "fixed-modal__content detail-sheet" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fixed-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_76 = { class: "fixed-modal__header" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fixed-eyebrow" }, "Detalhes", -1))
const _hoisted_78 = { id: "detail-title" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-calendar-check",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_82 = { class: "detail-grid" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Categoria", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Próximo vencimento", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Situação", -1))
const _hoisted_86 = { class: "detail-actions" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-pencil-simple",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-trash",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_89 = {
  key: 1,
  class: "fixed-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "form-title"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fixed-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_91 = { class: "fixed-modal__header" }
const _hoisted_92 = { class: "fixed-eyebrow" }
const _hoisted_93 = { id: "form-title" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = { class: "fixed-form-grid" }
const _hoisted_97 = { class: "field-wide" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome", -1))
const _hoisted_99 = { class: "field-wide recurring-amount-field" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "R$", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Frequência", -1))
const _hoisted_103 = ["value"]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Categoria", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Outros (automático)", -1))
const _hoisted_106 = ["value"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Próximo vencimento", -1))
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 0,
  class: "fixed-feedback fixed-feedback--error mt-15",
  role: "alert"
}
const _hoisted_110 = {
  key: 2,
  class: "confirm-modal",
  role: "alertdialog",
  "aria-modal": "true",
  "aria-labelledby": "confirm-title"
}
const _hoisted_111 = { class: "confirm-modal__content" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirm-modal__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-trash",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "confirm-title" }, "Excluir compromisso?", -1))
const _hoisted_114 = ["disabled"]
const _hoisted_115 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinancialPrivacyButton = _resolveComponent("FinancialPrivacyButton")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FinancialPrivacyButton),
        _createElementVNode("button", {
          class: "refresh-button",
          type: "button",
          disabled: _ctx.getLoadingFinance,
          "aria-label": "Atualizar compromissos",
          title: "Atualizar compromissos",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ph ph-arrow-clockwise", { 'is-spinning': _ctx.getLoadingFinance }]),
            "aria-hidden": "true"
          }, null, 2)
        ], 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.privateValue(_ctx.monthlyEstimate)), 1),
          _hoisted_11,
          (_ctx.unestimatedCount)
            ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.unestimatedCount) + " " + _toDisplayString(_ctx.unestimatedCount === 1 ? 'item não entrou' : 'itens não entraram') + " na estimativa por possuir frequência personalizada. ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "estimate-card__aside estimate-card__add",
          type: "button",
          "aria-label": "Cadastrar novo compromisso",
          title: "Novo compromisso",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
        }, _hoisted_15)
      ]),
      _createElementVNode("section", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_18, "Seus compromissos: " + _toDisplayString(_ctx.activeCount), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.agendaView === 'calendar' ? _ctx.calendarSummary : _ctx.paginationSummary), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.getFinanceRecurringExpenses.length && _ctx.agendaView === 'list')
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _createTextVNode(" Toque para ver detalhes "),
                  _hoisted_21
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "agenda-view-toggle",
              type: "button",
              "aria-label": _ctx.agendaView === 'list' ? 'Ver compromissos no calendário' : 'Ver compromissos em lista',
              title: _ctx.agendaView === 'list' ? 'Visualização em calendário' : 'Visualização em lista',
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAgendaView && _ctx.toggleAgendaView(...args)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.agendaView === 'list' ? 'ph ph-calendar-blank' : 'ph ph-list-bullets'),
                "aria-hidden": "true"
              }, null, 2)
            ], 8, _hoisted_22)
          ])
        ]),
        _createElementVNode("nav", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agendaTabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.value,
              type: "button",
              role: "tab",
              class: _normalizeClass({ active: _ctx.filters.status === tab.value }),
              "aria-selected": _ctx.filters.status === tab.value,
              onClick: ($event: any) => (_ctx.changeAgendaTab(tab.value))
            }, [
              _createTextVNode(_toDisplayString(tab.label) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(tab.count), 1)
            ], 10, _hoisted_24))
          }), 128))
        ]),
        (_ctx.getFinanceError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("span", null, _toDisplayString(_ctx.getFinanceError), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
              }, "Tentar novamente")
            ]))
          : _createCommentVNode("", true),
        (_ctx.getLoadingFinance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
                return _createElementVNode("div", {
                  key: item,
                  class: "fixed-skeleton"
                }, _hoisted_31)
              }), 64))
            ]))
          : (_ctx.agendaView === 'calendar')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["calendar-view", { 'has-selection': _ctx.selectedCalendarDay }])
              }, [
                _createElementVNode("header", _hoisted_32, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Mês anterior",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeCalendarMonth(-1)))
                  }, _hoisted_34),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.calendarMonthLabel), 1),
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Próximo mês",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCalendarMonth(1)))
                  }, _hoisted_36)
                ]),
                (_ctx.calendarError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", null, [
                        _hoisted_38,
                        _createElementVNode("span", null, _toDisplayString(_ctx.calendarError), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.loadCalendarData && _ctx.loadCalendarData(...args)))
                      }, "Tentar novamente")
                    ]))
                  : (_ctx.calendarLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(35, (item) => {
                          return _createElementVNode("span", {
                            key: item,
                            class: "skeleton"
                          })
                        }), 64))
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", {
                          class: "calendar-grid",
                          role: "grid",
                          "aria-label": `Compromissos de ${_ctx.calendarMonthLabel}`
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarWeekdays, (weekday) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: weekday,
                              class: "calendar-weekday",
                              role: "columnheader"
                            }, _toDisplayString(weekday), 1))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarDays, (day) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: day.key,
                              type: "button",
                              class: _normalizeClass(["calendar-day", {
                  'is-outside': !day.inMonth,
                  'is-today': day.isToday,
                  'is-past': day.isPast,
                  'has-items': day.items.length,
                  'is-selected': _ctx.selectedCalendarDateKey === day.key,
                }]),
                              "aria-label": _ctx.calendarDayAriaLabel(day),
                              "aria-pressed": _ctx.selectedCalendarDateKey === day.key,
                              onClick: ($event: any) => (_ctx.selectCalendarDay(day))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(day.day), 1),
                              (day.items.length)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_42, _toDisplayString(day.items.length), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_41))
                          }), 128))
                        ], 8, _hoisted_40),
                        (_ctx.selectedCalendarDay)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createElementVNode("header", null, [
                                _createElementVNode("div", null, [
                                  _hoisted_44,
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCalendarSelectionDate(_ctx.selectedCalendarDay.date)), 1)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.selectedCalendarDay.items.length), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCalendarDay.items, (item) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: `${_ctx.selectedCalendarDay.key}-${item.id}`,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.openDetails(item))
                                }, [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                                    _createElementVNode("small", null, _toDisplayString(item.category?.name || 'Sem categoria'), 1)
                                  ]),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(_ctx.money(item.amount))), 1),
                                  _hoisted_46
                                ], 8, _hoisted_45))
                              }), 128))
                            ], 512))
                          : (!_ctx.calendarMonthOccurrenceCount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_50))
                            : _createCommentVNode("", true)
                      ], 64))
              ], 2))
            : (_ctx.getFinanceRecurringExpenses.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinanceRecurringExpenses, (item) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: item.id,
                        class: _normalizeClass(["fixed-item", { 'is-overdue': _ctx.isOverdue(item.next_due_date) }]),
                        role: "button",
                        tabindex: "0",
                        "aria-label": `Ver detalhes de ${item.name}`,
                        onClick: ($event: any) => (_ctx.openDetails(item)),
                        onKeydown: [
                          _withKeys(($event: any) => (_ctx.openDetails(item)), ["enter"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.openDetails(item)), ["prevent"]), ["space"])
                        ]
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["date-badge", { 'is-empty': !item.next_due_date }])
                        }, [
                          (item.next_due_date)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.dateParts(item.next_due_date).day), 1),
                                _createElementVNode("small", null, _toDisplayString(_ctx.dateParts(item.next_due_date).month), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("i", _hoisted_53))
                        ], 2),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(item.category?.name || 'Sem categoria') + " ", 1),
                            _hoisted_55,
                            _createTextVNode(" " + _toDisplayString(_ctx.frequencyLabel(item.frequency)), 1)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["fixed-item__due", { 'is-overdue': _ctx.isOverdue(item.next_due_date) }])
                        }, [
                          _hoisted_56,
                          _createElementVNode("span", null, _toDisplayString(_ctx.dueLabel(item.next_due_date)), 1)
                        ], 2),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(item.amount))), 1),
                          _createElementVNode("small", null, _toDisplayString(_ctx.frequencyShortLabel(item.frequency)), 1)
                        ]),
                        _hoisted_58
                      ], 42, _hoisted_52))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.paginationSummary), 1),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("button", {
                        type: "button",
                        disabled: _ctx.currentPage <= 1,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                      }, "Anterior", 8, _hoisted_62),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationPages, (page) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: page,
                          type: "button",
                          class: _normalizeClass({ active: page === _ctx.currentPage }),
                          "aria-current": page === _ctx.currentPage ? 'page' : undefined,
                          onClick: ($event: any) => (_ctx.goToPage(page))
                        }, _toDisplayString(page), 11, _hoisted_63))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        disabled: _ctx.currentPage >= _ctx.lastPage,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                      }, "Próxima", 8, _hoisted_64)
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "Página anterior",
                        disabled: _ctx.currentPage <= 1,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                      }, _hoisted_68, 8, _hoisted_66),
                      _createElementVNode("span", null, "Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.lastPage), 1),
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "Próxima página",
                        disabled: _ctx.currentPage >= _ctx.lastPage,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                      }, _hoisted_71, 8, _hoisted_69)
                    ])
                  ])
                ], 64))
              : (!_ctx.getFinanceError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.filters.status === 'all' ? 'ph ph-calendar-plus' : 'ph ph-check-circle'),
                        "aria-hidden": "true"
                      }, null, 2)
                    ]),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.emptyStateTitle), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.emptyStateDescription), 1),
                    (_ctx.filters.status !== 'all')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeAgendaTab('all')))
                        }, "Ver todos os compromissos"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.selectedRecurring)
      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
          _createElementVNode("div", {
            class: "fixed-modal__backdrop",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeDetails && _ctx.closeDetails(...args)))
          }),
          _createElementVNode("section", _hoisted_74, [
            _hoisted_75,
            _createElementVNode("header", _hoisted_76, [
              _createElementVNode("div", null, [
                _hoisted_77,
                _createElementVNode("h2", _hoisted_78, _toDisplayString(_ctx.selectedRecurring.name), 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.selectedRecurring.owner?.name), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar detalhes",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeDetails && _ctx.closeDetails(...args)))
              }, _hoisted_80)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["detail-amount", { 'is-overdue': _ctx.isOverdue(_ctx.selectedRecurring.next_due_date) }])
            }, [
              _hoisted_81,
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_ctx.frequencyLabel(_ctx.selectedRecurring.frequency)), 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(_ctx.selectedRecurring.amount))), 1)
              ])
            ], 2),
            _createElementVNode("dl", _hoisted_82, [
              _createElementVNode("div", null, [
                _hoisted_83,
                _createElementVNode("dd", null, _toDisplayString(_ctx.selectedRecurring.category?.name || 'Sem categoria'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_84,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.selectedRecurring.next_due_date)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_85,
                _createElementVNode("dd", {
                  class: _normalizeClass({ 'is-overdue': _ctx.isOverdue(_ctx.selectedRecurring.next_due_date) })
                }, _toDisplayString(_ctx.dueLabel(_ctx.selectedRecurring.next_due_date)), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              (_ctx.selectedRecurring.can_edit !== false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openEditModal(_ctx.selectedRecurring)))
                  }, [
                    _hoisted_87,
                    _createTextVNode(" Editar")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedRecurring.can_edit !== false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "is-danger",
                    type: "button",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.requestDelete(_ctx.selectedRecurring)))
                  }, [
                    _hoisted_88,
                    _createTextVNode(" Excluir")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFormModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
          _createElementVNode("div", {
            class: "fixed-modal__backdrop",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeFormModal && _ctx.closeFormModal(...args)))
          }),
          _createElementVNode("form", {
            class: "fixed-modal__content",
            onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRecurring && _ctx.submitRecurring(...args)), ["prevent"]))
          }, [
            _hoisted_90,
            _createElementVNode("header", _hoisted_91, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.editingId ? 'Editar compromisso' : 'Novo compromisso'), 1),
                _createElementVNode("h2", _hoisted_93, _toDisplayString(_ctx.editingId ? 'Atualize os detalhes' : 'O que se repete?'), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeFormModal && _ctx.closeFormModal(...args)))
              }, _hoisted_95)
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("label", _hoisted_97, [
                _hoisted_98,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.name) = $event)),
                  class: "form-control",
                  maxlength: "120",
                  required: "",
                  placeholder: "Ex: aluguel, internet"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", _hoisted_99, [
                _hoisted_100,
                _createElementVNode("div", null, [
                  _hoisted_101,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.amountInput) = $event)),
                    type: "text",
                    inputmode: "numeric",
                    autocomplete: "off",
                    placeholder: "0,00",
                    "aria-label": "Valor do compromisso",
                    required: "",
                    onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.sanitizeAmountInput && _ctx.sanitizeAmountInput(...args))),
                    onPaste: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAmountPaste && _ctx.handleAmountPaste(...args)), ["prevent"]))
                  }, null, 544), [
                    [_vModelText, _ctx.amountInput]
                  ])
                ])
              ]),
              _createElementVNode("label", null, [
                _hoisted_102,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.frequency) = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencyOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_103))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.form.frequency]
                ])
              ]),
              _createElementVNode("label", null, [
                _hoisted_104,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.category_id) = $event)),
                  class: "form-select"
                }, [
                  _hoisted_105,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinanceCategories, (category) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: category.id,
                      value: category.id
                    }, _toDisplayString(category.name), 9, _hoisted_106))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.form.category_id]
                ])
              ]),
              _createElementVNode("label", null, [
                _hoisted_107,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.next_due_date) = $event)),
                  type: "date",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.form.next_due_date]
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "save-fixed-button",
              type: "submit",
              disabled: _ctx.saving
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Salvando...' : _ctx.editingId ? 'Salvar alterações' : 'Salvar compromisso'), 1),
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.saving ? 'ph ph-spinner-gap is-spinning' : 'ph ph-arrow-right'),
                "aria-hidden": "true"
              }, null, 2)
            ], 8, _hoisted_108),
            (_ctx.feedback)
              ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.feedback), 1))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.pendingDelete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
          _createElementVNode("div", {
            class: "confirm-modal__backdrop",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
          }),
          _createElementVNode("section", _hoisted_111, [
            _hoisted_112,
            _hoisted_113,
            _createElementVNode("p", null, "“" + _toDisplayString(_ctx.pendingDelete.name) + "” sairá da agenda e dos resumos, mas o histórico será preservado.", 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.deleting,
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
              }, "Cancelar", 8, _hoisted_114),
              _createElementVNode("button", {
                class: "is-danger",
                type: "button",
                disabled: _ctx.deleting,
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
              }, _toDisplayString(_ctx.deleting ? 'Excluindo...' : 'Sim, excluir'), 9, _hoisted_115)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}